import { render, staticRenderFns } from "./sch_jyqktj.vue?vue&type=template&id=aecdb32e&scoped=true"
import script from "./sch_jyqktj.vue?vue&type=script&lang=js"
export * from "./sch_jyqktj.vue?vue&type=script&lang=js"
import style0 from "./sch_jyqktj.vue?vue&type=style&index=0&id=aecdb32e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecdb32e",
  null
  
)

export default component.exports